import { client } from '@api/client';
import { URL } from '@api/urls';

import { TNameTitle } from '@interfaces/common/common';
import { TDefaultDTOWithoutPagination } from '@interfaces/common/defaultDTO';
import {
	IAssetSubTypeDTO,
	IAssetSubTypeUpdateDTO,
	IAssetTypeDTO,
	IAssetTypeUpdateDTO,
} from '@interfaces/platform/dto/manageAssetTypesDTO';
import {
	IManageAssetSubTypeItem,
	IManageAssetTypeItem,
} from '@interfaces/platform/manageAssetTypes';

const {
	assetsTypeManagement,
	assetsSubTypeManagement,
} = URL;

export const getAssetSubType = (id: string): Promise<IManageAssetSubTypeItem> => {
	return client.get(`${assetsSubTypeManagement}/${id}`);
};

export const deleteAssetSubType = (id: string): Promise<void> => {
	return client.post(`${assetsSubTypeManagement}/${id}/delete`, {});
};

export const updateAssetSubType = (props: IAssetSubTypeUpdateDTO): Promise<void> => {
	const { id, ...dto } = props;

	return client.post(`${assetsSubTypeManagement}/${id}/update`, dto);
};

export const createAssetSubType = (dto: IAssetSubTypeDTO): Promise<void> => {
	return client.post(`${assetsSubTypeManagement}/create`, dto);
};

export const getAllAssetTypes = (params: TDefaultDTOWithoutPagination): Promise<IManageAssetTypeItem[]> => {
	return client.get(assetsTypeManagement, {
		params,
	});
};

export const getAssetType = (id: string): Promise<IManageAssetTypeItem> => {
	return client.get(`${assetsTypeManagement}/${id}`);
};

export const deleteAssetType = (id: string): Promise<void> => {
	return client.post(`${assetsTypeManagement}/${id}/delete`, {});
};

export const updateAssetType = (props: IAssetTypeUpdateDTO): Promise<IManageAssetTypeItem> => {
	const { id, ...dto } = props;

	return client.post(`${assetsTypeManagement}/${id}/update`, dto);
};

export const createAssetType = (dto: IAssetTypeDTO): Promise<IManageAssetTypeItem> => {
	return client.post(`${assetsTypeManagement}/create`, dto);
};

export const createUploadUrlAssetType = (fileName: string): Promise<IManageAssetTypeItem> => {
	return client.post(`${assetsTypeManagement}/icon/create-upload-url`, { fileName });
};

export const getNonRequiredFieldsForAssetTypes = (): Promise<TNameTitle[]> => {
	return client.get(`${assetsTypeManagement}/get-non-required-system-fields`);
};

export const checkAssetTypeName = (name: string): Promise<boolean> => {
	return client.post(`${assetsTypeManagement}/check`, { name });
};

export const checkAssetSubTypeName = (name: string): Promise<boolean> => {
	return client.post(`${assetsSubTypeManagement}/check`, { name });
};
